<template>
  <modal
    :title="setModel.ProviderMarketName + ' - Match Provider Markets'"
    @close="$emit('close')"
  >
    <template #content>
      <loadArea v-if="countries.length == 0"></loadArea>
      <Form
        method="dialog"
        v-slot="{ errors }"
        class="floating-labels p-1rem row"
        ref="form"
        v-if="countries.length > 0"
      >
        <selectBox
          :title="'CountryId'"
          v-model.number="model.CountryId"
          :errors="errors"
          :rules="{ required: true }"
          :buttons="true"
          @keydown.enter="save"
        >
          <template #search>
            <input
              type="text"
              placeholder="Ara"
              class="form-control small"
              v-model="searchCountry"
            />
          </template>
          <template #input>
            <template v-for="item in countries">
              <option
                :value="item.Id"
                :key="item.Id"
                v-if="
                  item.Name.toUpperCase().indexOf(searchCountry.toUpperCase()) >
                    -1
                "
                >{{ item.Name }}</option
              >
            </template>
          </template>
          <template #buttons>
            <button
              type="button"
              @click="addCountryOpen = true"
              class="btn waves-effect waves-light btn-success"
            >
              <i class="fas fa-plus"></i>
            </button>
          </template>
        </selectBox>
      </Form>
    </template>
    <template v-if="countries.length > 0" #foot>
      <Btn class="btn-success btn-md" @click="save" :process="process"
        >Match Provider Markets</Btn
      >
    </template>
  </modal>
  <addCountry
    v-if="addCountryOpen"
    @close="addCountryOpen = false"
    @add="setCountry($event)"
  ></addCountry>
</template>

<script>
import selectBox from "@/components/formGroup/selectBox";
import addCountry from "@/views/countries/upsert";
export default {
  props: {
    setModel: Object,
    countries: Array,
  },
  components: { selectBox, addCountry },
  data() {
    return {
      searchCountry: "",
      addCountryOpen: false,
      model: {
        Id: this.setModel.Id,
        CountryId: this.setModel.CountryId,
      },
      errs: {},
      process: false,
    };
  },
  created() {
    var name = this.setModel.ProviderMarketName;
    this.searchCountry = name.substring(0, 3);
    if (this.countries.length == 0) {
      this.$appAxiosAdmin.get(`Countries`).then((response) => {
        this.$emit("setCountries", response.data);
      });
    }
  },
  methods: {
    setCountry(item) {
      var data = this.countries;
      data.unshift({
        Id: item.Id,
        Name: item.Name,
      });
      this.$emit("setCountries", data);
    },
    save() {
      this.$refs.form.validate().then((valid) => {
        if (valid.valid) {
          this.process = true;
          this.$appAxiosAdmin
            .post(`KOLAYREZ/ProviderMarkets/Match/`, this.model)
            .then(() => {
              this.$appAxiosAdmin
                .get(`kolayrez/ProviderMarkets/` + this.model.Id)
                .then((response) => {
                  this.process = false;
                  this.$swal({
                    icon: "success",
                    title: "Success",
                    text: "Provider market matched.",
                    timer: 2000,
                    confirmButtonText: "Okey",
                  });
                  this.$emit("update", response.data);
                  this.$emit("close");
                });
            })
            .catch((err) => {
              this.$isError(err);
            });
        }
      });
    },
  },
};
</script>

<style></style>
